(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["daily-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('daily-banner')) {
  class DailyBanner extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-daily-slide]'));
      if (!this.slides.length) return;

      this.countdown = this.querySelector('[data-countdown]');
      this.daysWrap = this.querySelector('[data-days-wrap]');
      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');
      this.editorNote = this.querySelector('[data-editor-note]');

      this.timeZone = this.dataset.timezone || 'Europe/Warsaw';
      this.showCountdown = this.dataset.showCountdown === 'true';
      this.designMode = this.dataset.designMode === 'true';
      this.pinnedIndex = null;
      this.stateKey = null;

      this.schedule = this.slides.map((slide) => ({
        start: this.parseDateTime(slide.dataset.startDate, slide.dataset.startTime, '00:00'),
        end: this.parseDateTime(slide.dataset.endDate, slide.dataset.endTime, '24:00')
      }));

      this.addEventListener('shopify:block:select', (e) => {
        const index = this.slides.indexOf(e.target.closest('[data-daily-slide]'));
        if (index > -1) {
          this.pinnedIndex = index;
          this.tick(true);
        }
      });
      this.addEventListener('shopify:block:deselect', () => {
        this.pinnedIndex = null;
        this.tick(true);
      });

      this.tick(true);
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    parseDateTime(date, time, fallbackTime) {
      const d = (date || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!d) return null;
      const t = ((time || '').trim() || fallbackTime).match(/^(\d{2}):(\d{2})$/);
      if (!t) return null;
      return Date.UTC(+d[1], +d[2] - 1, +d[3], +t[1], +t[2]);
    }

    /* Aktualny czas „ścienny” w wybranej strefie, zapisany jako UTC – porównywalny z datami z bloków */
    getNow() {
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      };
      let parts;
      try {
        parts = new Intl.DateTimeFormat('en-GB', { ...options, timeZone: this.timeZone }).formatToParts(new Date());
      } catch (err) {
        parts = new Intl.DateTimeFormat('en-GB', options).formatToParts(new Date());
      }
      const get = (type) => parseInt(parts.find((p) => p.type === type).value, 10);
      return Date.UTC(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'), get('second'));
    }

    getState(now) {
      let index = -1;
      let activeStart = -Infinity;
      let activeEnd = null;
      let nextStart = null;

      this.schedule.forEach((item, i) => {
        if (item.start === null) return;
        if (item.start > now) {
          if (nextStart === null || item.start < nextStart) nextStart = item.start;
          return;
        }
        if (item.start >= activeStart && (item.end === null || item.end > now)) {
          index = i;
          activeStart = item.start;
          activeEnd = item.end;
        }
      });

      let target = null;
      if (index > -1) {
        target = nextStart;
        if (activeEnd !== null && (target === null || activeEnd < target)) target = activeEnd;
      }

      return { index, hidden: index === -1, target };
    }

    apply(state) {
      let index = state.index;
      let hidden = state.hidden;

      if (this.editorNote) this.editorNote.hidden = !hidden;
      if (this.pinnedIndex !== null) index = this.pinnedIndex;
      if (this.designMode) hidden = false;
      if (index === -1) index = 0;

      this.hidden = hidden;
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== index;
      });
    }

    tick(force = false) {
      const now = this.getNow();
      const state = this.getState(now);
      const key = `${state.index}|${state.target}`;

      if (force || key !== this.stateKey) {
        this.stateKey = key;
        this.apply(state);
      }

      if (!this.countdown) return;

      const visible = this.showCountdown && !state.hidden && state.target !== null;
      this.countdown.hidden = !visible;
      if (!visible) return;

      const left = Math.max(0, Math.floor((state.target - now) / 1000));
      const days = Math.floor(left / 86400);
      const pad = (n) => String(n).padStart(2, '0');

      this.daysWrap.hidden = days === 0;
      this.daysEl.textContent = days;
      this.hoursEl.textContent = pad(Math.floor((left % 86400) / 3600));
      this.minutesEl.textContent = pad(Math.floor((left % 3600) / 60));
      this.secondsEl.textContent = pad(left % 60);
    }
  }

  customElements.define('daily-banner', DailyBanner);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dziennik-dobrych-wnetrz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ddw-scroller')) {
    class DdwScroller extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ddw-track]');
        this.nav = this.querySelector('[data-ddw-nav]');
        this.dotsEl = this.querySelector('[data-ddw-dots]');
        if (!this.track || !this.nav || !this.dotsEl) return;

        this.count = 0;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = null;
            this.mark();
          });
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.querySelector('[data-ddw-prev]').addEventListener('click', () => this.go(this.current() - 1));
        this.querySelector('[data-ddw-next]').addEventListener('click', () => this.go(this.current() + 1));

        this.ro = new ResizeObserver(() => this.build());
        this.ro.observe(this.track);

        this.onBlockSelect = (e) => {
          if (!this.track.contains(e.target)) return;
          e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.build();
      }

      disconnectedCallback() {
        this.ro?.disconnect();
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      maxScroll() {
        return this.track.scrollWidth - this.track.clientWidth;
      }

      stride() {
        const cs = getComputedStyle(this.track);
        const inner = this.track.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
        const gap = parseFloat(cs.columnGap) || 0;
        return inner + gap;
      }

      pages() {
        const max = this.maxScroll();
        if (max <= 2) return 1;
        return Math.ceil(max / this.stride() - 0.05) + 1;
      }

      current() {
        if (this.track.scrollLeft >= this.maxScroll() - 2) return this.pages() - 1;
        return Math.round(this.track.scrollLeft / this.stride());
      }

      go(k) {
        const n = this.pages();
        const page = ((k % n) + n) % n;
        this.track.scrollTo({
          left: Math.min(page * this.stride(), this.maxScroll()),
          behavior: this.reduced ? 'auto' : 'smooth'
        });
      }

      build() {
        const n = this.pages();
        this.nav.hidden = n < 2;

        if (n !== this.count) {
          this.count = n;
          this.dotsEl.innerHTML = '';
          for (let k = 0; k < n; k++) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'ddw__dot';
            dot.setAttribute('aria-label', `Strona ${k + 1} z ${n}`);
            dot.addEventListener('click', () => this.go(k));
            this.dotsEl.appendChild(dot);
          }
        }
        this.mark();
      }

      mark() {
        const k = this.current();
        [...this.dotsEl.children].forEach((dot, j) => {
          const active = j === k;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('ddw-scroller', DdwScroller);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["good-interior-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('carousel-loop-el')) {
  class CarouselLoopEl extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.slides = Array.from(this.track.children);
      this.originalCount = this.slides.length;
      this.prevBtn = this.querySelector('[data-carousel-prev]');
      this.nextBtn = this.querySelector('[data-carousel-next]');

      if (this.originalCount < 2) return;

      this.maxVisible = Math.max(
        parseInt(this.dataset.visibleDesktop, 10) || 1,
        parseInt(this.dataset.visibleTablet, 10) || 1,
        parseInt(this.dataset.visibleMobile, 10) || 1
      );

      this.cloneSlides();
      this.bindEvents();

      requestAnimationFrame(() => this.goToRealStart(false));
      window.addEventListener('resize', this.debounce(() => this.goToRealStart(false), 200));
    }

    cloneSlides() {
      const need = this.maxVisible;
      let prepend = [];
      let append = [];

      if (this.originalCount >= need) {
        prepend = this.slides.slice(this.originalCount - need);
        append = this.slides.slice(0, need);
      } else {
        while (prepend.length < need) prepend = this.slides.concat(prepend);
        prepend = prepend.slice(prepend.length - need);
        while (append.length < need) append = append.concat(this.slides);
        append = append.slice(0, need);
      }

      prepend
        .slice()
        .reverse()
        .forEach((slide) => this.track.insertBefore(slide.cloneNode(true), this.track.firstChild));
      append.forEach((slide) => this.track.appendChild(slide.cloneNode(true)));

      this.prependCount = prepend.length;
    }

    getSlideStep() {
      const items = this.track.children;
      if (items.length < 2) return items[0] ? items[0].offsetWidth : 0;
      const a = items[this.prependCount].getBoundingClientRect().left;
      const b = items[this.prependCount + 1].getBoundingClientRect().left;
      return Math.abs(b - a) || items[0].offsetWidth;
    }

    goToRealStart(smooth) {
      const step = this.getSlideStep();
      this.track.scrollTo({ left: step * this.prependCount, behavior: smooth ? 'smooth' : 'instant' });
    }

    bindEvents() {
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.track.scrollBy({ left: this.getSlideStep(), behavior: 'smooth' });
        });
      }
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.track.scrollBy({ left: -this.getSlideStep(), behavior: 'smooth' });
        });
      }

      let scrollTimeout;
      this.track.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => this.checkLoopBoundary(), 120);
      });

      this.enableDrag();
    }

    checkLoopBoundary() {
      const step = this.getSlideStep();
      if (!step) return;
      const index = Math.round(this.track.scrollLeft / step);
      const realStart = this.prependCount;
      const realEnd = this.prependCount + this.originalCount - 1;

      if (index < realStart) {
        this.track.scrollTo({ left: this.track.scrollLeft + step * this.originalCount, behavior: 'instant' });
      } else if (index > realEnd) {
        this.track.scrollTo({ left: this.track.scrollLeft - step * this.originalCount, behavior: 'instant' });
      }
    }

    enableDrag() {
      let isDown = false;
      let hasDragged = false;
      let startX = 0;
      let startScroll = 0;
      const dragThreshold = 5;

      this.track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') return;
        isDown = true;
        hasDragged = false;
        startX = e.clientX;
        startScroll = this.track.scrollLeft;
      });

      document.addEventListener('pointermove', (e) => {
        if (!isDown) return;
        const dx = e.clientX - startX;
        if (!hasDragged && Math.abs(dx) > dragThreshold) {
          hasDragged = true;
          this.track.classList.add('is-dragging');
        }
        if (hasDragged) {
          this.track.scrollLeft = startScroll - dx;
        }
      });

      const stopDrag = () => {
        if (!isDown) return;
        isDown = false;
        this.track.classList.remove('is-dragging');
        if (hasDragged) {
          this.checkLoopBoundary();
        }
      };

      document.addEventListener('pointerup', stopDrag);
      document.addEventListener('pointercancel', stopDrag);

      this.track.addEventListener(
        'click',
        (e) => {
          if (hasDragged) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), wait);
      };
    }
  }

  customElements.define('carousel-loop-el', CarouselLoopEl);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selsey-design-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sds-slider')) {
    class SdsSlider extends HTMLElement {
      connectedCallback() {
        this.texts = [...this.querySelectorAll('[data-sds-text]')];
        this.medias = [...this.querySelectorAll('[data-sds-media]')];
        this.dots = [...this.querySelectorAll('[data-sds-dot]')];
        this.count = this.texts.length;
        this.index = 0;
        this.visible = false;
        this.paused = false;
        this.editorLock = false;

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduced && this.count > 1;
        this.speed = (parseInt(this.dataset.speed, 10) || 6) * 1000;

        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.syncVideos();
          this.restart();
        }, { threshold: 0.25 });
        this.observer.observe(this);

        if (this.count < 2) return;

        this.querySelector('[data-sds-prev]')?.addEventListener('click', () => this.goTo(this.index - 1));
        this.querySelector('[data-sds-next]')?.addEventListener('click', () => this.goTo(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.sdsDot))));

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.goTo(this.index - 1);
          if (e.key === 'ArrowRight') this.goTo(this.index + 1);
        });

        let startX = null;
        let startY = null;
        this.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          if (e.target.closest('a, button')) return;
          startX = e.clientX;
          startY = e.clientY;
        }, { passive: true });
        this.addEventListener('pointerup', (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          const dy = e.clientY - startY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.goTo(this.index + (dx < 0 ? 1 : -1));
          startX = null;
        });
        this.addEventListener('pointercancel', () => { startX = null; });

        this.addEventListener('mouseenter', () => { this.paused = true; this.restart(); });
        this.addEventListener('mouseleave', () => { this.paused = false; this.restart(); });
        this.addEventListener('focusin', () => { this.paused = true; this.restart(); });
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) { this.paused = false; this.restart(); }
        });

        this.onBlockSelect = (e) => {
          if (!this.contains(e.target)) return;
          this.editorLock = true;
          this.goTo(Number(e.target.dataset.index));
        };
        this.onBlockDeselect = (e) => {
          if (!this.contains(e.target)) return;
          this.editorLock = false;
          this.restart();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.onBlockDeselect) document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      goTo(i) {
        if (Number.isNaN(i)) return;
        const next = ((i % this.count) + this.count) % this.count;

        this.texts.forEach((el, k) => this.setState(el, k === next, true));
        this.medias.forEach((el, k) => this.setState(el, k === next, false));
        this.dots.forEach((dot, k) => {
          dot.classList.toggle('is-active', k === next);
          if (k === next) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        this.index = next;
        this.syncVideos();
        this.restart();
      }

      setState(el, active, useInert) {
        el.classList.toggle('is-active', active);
        if (active) {
          el.removeAttribute('aria-hidden');
          if (useInert) el.inert = false;
        } else {
          el.setAttribute('aria-hidden', 'true');
          if (useInert) el.inert = true;
        }
      }

      syncVideos() {
        this.medias.forEach((media, k) => {
          const video = media.querySelector('video');
          if (!video) return;
          if (k === this.index && this.visible) {
            video.muted = true;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      restart() {
        clearTimeout(this.timer);
        if (!this.autoplay || this.paused || this.editorLock || !this.visible) return;
        this.timer = setTimeout(() => this.goTo(this.index + 1), this.speed);
      }
    }

    customElements.define('sds-slider', SdsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spl-slider')) {
    class SplSlider extends HTMLElement {
      connectedCallback() {
        this.texts = [...this.querySelectorAll('[data-spl-text]')];
        this.medias = [...this.querySelectorAll('[data-spl-media]')];
        this.dots = [...this.querySelectorAll('[data-spl-dot]')];
        this.count = this.texts.length;
        this.index = 0;
        this.visible = false;
        this.paused = false;
        this.editorLock = false;

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduced && this.count > 1;
        this.speed = (parseInt(this.dataset.speed, 10) || 6) * 1000;

        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.syncVideos();
          this.restart();
        }, { threshold: 0.25 });
        this.observer.observe(this);

        if (this.count < 2) return;

        this.querySelector('[data-spl-prev]')?.addEventListener('click', () => this.goTo(this.index - 1));
        this.querySelector('[data-spl-next]')?.addEventListener('click', () => this.goTo(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.splDot))));

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.goTo(this.index - 1);
          if (e.key === 'ArrowRight') this.goTo(this.index + 1);
        });

        let startX = null;
        let startY = null;
        this.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          if (e.target.closest('a, button')) return;
          startX = e.clientX;
          startY = e.clientY;
        }, { passive: true });
        this.addEventListener('pointerup', (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          const dy = e.clientY - startY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.goTo(this.index + (dx < 0 ? 1 : -1));
          startX = null;
        });
        this.addEventListener('pointercancel', () => { startX = null; });

        this.addEventListener('mouseenter', () => { this.paused = true; this.restart(); });
        this.addEventListener('mouseleave', () => { this.paused = false; this.restart(); });
        this.addEventListener('focusin', () => { this.paused = true; this.restart(); });
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) { this.paused = false; this.restart(); }
        });

        this.onBlockSelect = (e) => {
          if (!this.contains(e.target)) return;
          this.editorLock = true;
          this.goTo(Number(e.target.dataset.index));
        };
        this.onBlockDeselect = (e) => {
          if (!this.contains(e.target)) return;
          this.editorLock = false;
          this.restart();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.onBlockDeselect) document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      goTo(i) {
        if (Number.isNaN(i)) return;
        const next = ((i % this.count) + this.count) % this.count;

        this.texts.forEach((el, k) => this.setState(el, k === next, true));
        this.medias.forEach((el, k) => this.setState(el, k === next, false));
        this.dots.forEach((dot, k) => {
          dot.classList.toggle('is-active', k === next);
          if (k === next) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        this.index = next;
        this.syncVideos();
        this.restart();
      }

      setState(el, active, useInert) {
        el.classList.toggle('is-active', active);
        if (active) {
          el.removeAttribute('aria-hidden');
          if (useInert) el.inert = false;
        } else {
          el.setAttribute('aria-hidden', 'true');
          if (useInert) el.inert = true;
        }
      }

      syncVideos() {
        this.medias.forEach((media, k) => {
          const video = media.querySelector('video');
          if (!video) return;
          if (k === this.index && this.visible) {
            video.muted = true;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      restart() {
        clearTimeout(this.timer);
        if (!this.autoplay || this.paused || this.editorLock || !this.visible) return;
        this.timer = setTimeout(() => this.goTo(this.index + 1), this.speed);
      }
    }

    customElements.define('spl-slider', SplSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
